import Header from "../../commons/header";
import Footer from "../../commons/footer";
import ProjectsMain from "./main";

const Projects = () => {
    return (
        <div className="projects-page">
            <Header />
            <ProjectsMain />
            <Footer />
        </div>
    )
};

export default Projects;
